import { useState } from "react";
import { Loader2, Radar, ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

const BG = "https://images.unsplash.com/photo-1727434032773-af3cd98375ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <div className="relative hidden overflow-hidden bg-[#0A0A0A] lg:block">
        <img src={BG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-50" />
        <div className="relative flex h-full flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-2 font-display text-xl font-black">
            <Radar className="h-6 w-6" /> AYA<span className="text-[#FF3B30]">.Lead</span>
          </div>
          <div className="max-w-md">
            <div className="eyebrow mb-4 !text-white/60">Local.ch · Search.ch · Google Maps · Zefix · Crawler</div>
            <h2 className="font-display text-5xl font-black leading-[1.02] tracking-tight">Prospection B2B suisse, fusionnée et conforme LPD.</h2>
          </div>
          <div className="flex items-center gap-2 text-xs text-white/60">
            <ShieldCheck className="h-4 w-4" /> Détection automatique de l'astérisque de refus de démarchage
          </div>
        </div>
      </div>
      <div className="grid-paper flex items-center px-6 py-16 sm:px-16">
        <form onSubmit={submit} data-testid="login-form" className="fade-up w-full max-w-sm rounded-lg border border-border bg-white p-8 shadow-sm">
          <div className="eyebrow mb-2">Accès sécurisé</div>
          <h1 className="font-display text-3xl font-black tracking-tight">Connexion</h1>
          <p className="mt-2 text-sm text-muted-foreground">Accès réservé aux comptes autorisés.</p>
          <div className="mt-8 space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">E-mail</Label>
              <Input id="email" data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Mot de passe</Label>
              <Input id="password" data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            {error && <div data-testid="login-error" className="rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-[#FF3B30]">{error}</div>}
            <Button data-testid="login-submit-button" type="submit" disabled={loading} className="w-full transition-transform hover:-translate-y-0.5">
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Se connecter
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
